import { Skillsvg } from "../svg"


export const SkillArr =[
    {title: "JavaScript", svg : Skillsvg.js},
    {title: "TypeScript", svg : Skillsvg.ts},
    {title: "Python", svg : Skillsvg.python},
    {title: "Java", svg : Skillsvg.java},
    {title: "SpringBoot", svg : Skillsvg.SpringBoot},
    {title: "AWS", svg : Skillsvg.aws},
    {title: "Kubernetes", svg : Skillsvg.kubernetes},
    {title: "Azure", svg : Skillsvg.azure},
    {title: "Docker", svg : Skillsvg.docker},
    {title: "React", svg : Skillsvg.React},
    {title: "Next", svg : Skillsvg.Next},
    {title: "Express", svg : Skillsvg.express},
    {title: "Mongodb", svg : Skillsvg.mongodb},
    {title: "Postgres", svg : Skillsvg.postgres},
    {title: "Redis", svg : Skillsvg.redis},
    {title: "Bash", svg : Skillsvg.bash},
    {title: "Jenkins", svg : Skillsvg.Jenkins},
    {title: "Redux", svg : Skillsvg.Redux},
    {title: "Angular", svg : Skillsvg.Angular},
    {title: "MySql", svg : Skillsvg.MySql},
    {title: "DotNet", svg : Skillsvg.DotNet},
    {title: "More", svg : Skillsvg.and},
]